import { FC } from 'react';
import { TraySummary } from 'api/models/Trays';
import { DeliveryChip } from 'components/DeliveryChip';
import theme from 'App.theme';

type TrayLabels = FC<{
  trays?: TraySummary[];
}>;

const TrayLabels: TrayLabels = ({ trays }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: theme.layout.spacing.tiny }}>
      {trays &&
        trays.map((tray, trayIndex) => {
          const decantedTrays = tray.inspections.length && tray.inspections[0].decantedTrays;

          return decantedTrays ? (
            decantedTrays.map((decantedTray, decantedIndex) => (
              <DeliveryChip
                key={`tray-${trayIndex}-decanted-${decantedIndex}`}
                variant="tray"
                width="21px"
                height="21px"
              >
                {decantedTray.trayReference || '-'}
              </DeliveryChip>
            ))
          ) : (
            <DeliveryChip key={`tray-${trayIndex}`} variant="tray" width="21px" height="21px">
              {tray?.trayReference || '-'}
            </DeliveryChip>
          );
        })}
    </div>
  );
};

export default TrayLabels;
